import {
    ESERIES_STORAGE_OBJECTS,
    ONTAP_STORAGE_OBJECTS,
    STORAGE_GRID_STORAGE_OBJECTS,
    SYSTEM_TYPES,
} from 'utils/fleet/fleetInventoryUtils';
import { RESOURCE_COUNT_GROUP_KEYS } from './fleetsSummaryMetricsUtils';
import { ALL_FLEETS_ID } from 'utils/fleet/FleetUtils';

export const getFleetDetailsLink = (fleetId) => ({
    pathname: `/fleets/${fleetId}`
});

export const getFleetInventoryByViewAndDimensionLink = (fleetId, objectType = ONTAP_STORAGE_OBJECTS.SYSTEMS, dimension, systemType) => {
    const searchParams = new URLSearchParams();
    if (dimension) {
        searchParams.set('dimension', dimension);
    }
    if (systemType) {
        searchParams.set('systemType', systemType);
    }
    const search = searchParams.toString();

    return {
        pathname: `/fleets/${fleetId}/inventory/${objectType}`,
        ...(search ? { search: `?${search}` } : {}),
    };
};

// Maps each count key on the fleet counts payload to its inventory tab. Count keys without
// a view (StorageGRID buckets, E-series pools and volume groups) stay text-only in the tooltip.
const RESOURCE_INVENTORY_BY_GROUP = {
    [RESOURCE_COUNT_GROUP_KEYS.ONTAP]: {
        views: {
            svms: ONTAP_STORAGE_OBJECTS.SVMS,
            volumes: ONTAP_STORAGE_OBJECTS.VOLUMES,
            luns: ONTAP_STORAGE_OBJECTS.LUNS,
            namespaces: ONTAP_STORAGE_OBJECTS.NAMESPACE,
            smbshares: ONTAP_STORAGE_OBJECTS.SMBSHARES,
            qtrees: ONTAP_STORAGE_OBJECTS.QTREES,
            aggregates: ONTAP_STORAGE_OBJECTS.LOCAL_TIERS,
        },
    },
    [RESOURCE_COUNT_GROUP_KEYS.STORAGEGRID]: {
        systemType: SYSTEM_TYPES.STORAGEGRID,
        views: {
            tenants: STORAGE_GRID_STORAGE_OBJECTS.TENANTS,
        },
    },
    [RESOURCE_COUNT_GROUP_KEYS.ESERIES]: {
        systemType: SYSTEM_TYPES.ESERIES,
        views: {
            volumes: ESERIES_STORAGE_OBJECTS.LUNS,
        },
    },
};

const SYSTEM_TYPE_BY_COUNT_GROUP = {
    [RESOURCE_COUNT_GROUP_KEYS.ONTAP]: SYSTEM_TYPES.ONTAP,
    [RESOURCE_COUNT_GROUP_KEYS.ESERIES]: SYSTEM_TYPES.ESERIES,
    [RESOURCE_COUNT_GROUP_KEYS.STORAGEGRID]: SYSTEM_TYPES.STORAGEGRID,
};

export const getResourceInventoryLink = (fleetId, groupKey, resourceKey) => {
    const { views, systemType } = RESOURCE_INVENTORY_BY_GROUP[groupKey] ?? {};
    const objectType = views?.[resourceKey];

    return objectType
        ? getFleetInventoryByViewAndDimensionLink(fleetId, objectType, undefined, systemType)
        : null;
};

export const getSystemInventoryLink = (fleetId, groupKey) => {
    const systemType = SYSTEM_TYPE_BY_COUNT_GROUP[groupKey];

    return systemType
        ? getFleetInventoryByViewAndDimensionLink(fleetId, ONTAP_STORAGE_OBJECTS.SYSTEMS, undefined, systemType)
        : null;
};

export const getFleetInventoryLink = (fleetId) => ({
    pathname: `/fleets/${fleetId}/inventory`
});

export const getAddSystemsLink = (fleetId, fleet) => ({
    pathname: `/fleets/${fleetId}/add-systems`,
    state: { fleet }
});

export const getAddVolumeLink = (fleetId, fleet) => ({
    pathname: `/fleets/${fleetId}/add-volume`,
    state: { fleet }
});

export const getAddLunLink = (fleetId, fleet) => ({
    pathname: `/fleets/${fleetId}/add-lun`,
    state: { fleet }
});

export const getAlertsLink = ({ fleetId, severities, organizationId }) => ({
    pathname: "/alerts/overview",
    ...(severities.length > 0 ? (
        organizationId && fleetId === ALL_FLEETS_ID ?
        { search: `?orgId=${organizationId}&severity=${severities.join(",")}` } :
        { search: `?fleetId=${fleetId}&severity=${severities.join(",")}` }
    ) : (
        organizationId && fleetId === ALL_FLEETS_ID ?
        { search: `?orgId=${organizationId}` } :
        { search: `?fleetId=${fleetId}` }
    )),
});

export const updateScopeToFleet = (dispatch, fleetId) => {
    if (!fleetId) {
        return;
    }

    dispatch({ type: "TENANCYV4:SET-SCOPE", payload: { scopeId: fleetId } });
};
